<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.7678 10.2422C14.7441 11.2185 14.7441 12.8014 13.7678 13.7777C12.7915 14.754 11.2086 14.754 10.2323 13.7777C9.25595 12.8014 9.25595 11.2185 10.2323 10.2422C11.2086 9.26587 12.7915 9.26587 13.7678 10.2422"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.849 4.13L15.432 4.324C15.966 4.502 16.327 5.002 16.327 5.565V6.402C16.327 7.114 16.895 7.695 17.607 7.71L18.445 7.728C18.93 7.738 19.37 8.017 19.587 8.451L19.862 9.001C20.114 9.505 20.015 10.113 19.617 10.511L19.025 11.103C18.522 11.606 18.513 12.419 19.005 12.933L19.585 13.539C19.921 13.89 20.035 14.397 19.881 14.858L19.687 15.441C19.509 15.975 19.009 16.336 18.446 16.336H17.609C16.897 16.336 16.316 16.904 16.301 17.616L16.283 18.454C16.273 18.939 15.994 19.379 15.56 19.596L15.01 19.871C14.506 20.123 13.898 20.024 13.5 19.626L12.908 19.034C12.405 18.531 11.592 18.522 11.078 19.014L10.472 19.594C10.121 19.93 9.614 20.044 9.153 19.89L8.57 19.696C8.036 19.518 7.675 19.018 7.675 18.455V17.618C7.675 16.906 7.107 16.325 6.395 16.31L5.557 16.292C5.072 16.282 4.632 16.003 4.415 15.569L4.14 15.019C3.888 14.515 3.987 13.907 4.385 13.509L4.977 12.917C5.48 12.414 5.489 11.601 4.997 11.087L4.417 10.481C4.08 10.129 3.966 9.621 4.12 9.161L4.314 8.578C4.492 8.044 4.992 7.683 5.555 7.683H6.392C7.104 7.683 7.685 7.115 7.7 6.403L7.718 5.565C7.73 5.08 8.008 4.64 8.442 4.423L8.992 4.148C9.496 3.896 10.104 3.995 10.502 4.393L11.094 4.985C11.597 5.488 12.41 5.497 12.924 5.005L13.53 4.425C13.881 4.09 14.389 3.976 14.849 4.13V4.13Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
